import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Notice from '@/components/Notice.vue';
import { format } from '@/utils/format';
import BigNumber from 'bignumber.js';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'DecreaseAmountNotice',
  props: {
    toAmount: null,
    symbol: null
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'click', value: { toAmount: BigNumber; symbol: string }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  toAmount: BigNumber;
  symbol: string;
}

const { t } = useI18n();





const translationParameter = computed(() => `${format(props.toAmount)} ${props.symbol}`);
const translationPath = 'portfolio.easyModeTranslations.common.notices.decreaseTotalAmount';

const translationHead = t(`${translationPath}.head`);
const translationTail = computed(() =>
  t(`${translationPath}.tail`, {
    value: translationParameter.value,
  }),
);

const onClick = () => {
  emits('click', { ...props });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Notice, { icon: "graph" }, {
    "notice-text": _withCtx(() => [
      _createElementVNode("span", {
        class: "clickable underline mr-s1",
        onClick: onClick
      }, _toDisplayString(_unref(translationHead)), 1),
      _createElementVNode("span", null, _toDisplayString(_unref(translationTail)), 1)
    ]),
    _: 1
  }))
}
}

})